module.exports = __webpack_public_path__ + "static/media/ENData Short Logo.601b85ef.png";